var slide1 = promokit.slide({
    el: '#slide-dungeon',
    arrow: true,
    infinity: true,
    bullet: true
});



// WEBPACK FOOTER //
// ./src/js/PC/section2.js